import { render, staticRenderFns } from "./SntLoading.vue?vue&type=template&id=4525ba84&scoped=true&"
import script from "./SntLoading.vue?vue&type=script&lang=js&"
export * from "./SntLoading.vue?vue&type=script&lang=js&"
import style0 from "./SntLoading.vue?vue&type=style&index=0&id=4525ba84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525ba84",
  null
  
)

export default component.exports